import type { FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { Token } from '@ui/config/token';

import { TokenListRow } from './TokenListRow';

export const TokenList = (props: FlexProps) => {
  return (
    <Flex flexDir="column" {...props}>
      <TokenListRow token={Token.agentFun} />
    </Flex>
  );
};
